import { Message } from 'element-ui'
import util from '@/libs/util'

// 优先用 JWT 的业务用户 ID 区分账号，避免同名用户共享布局；旧缓存按用户名兼容。
function accountStoragePath () {
  let account = util.cookies.get('name')
  const token = util.cookies.get('jwt_token')
  if (token) {
    try {
      const encoded = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
      const payload = JSON.parse(atob(encoded))
      if (typeof payload.sub === 'string' && payload.sub) account = `id:${payload.sub}`
    } catch (error) {
      // 布局键只读取标识；令牌有效性继续由后端校验，解析失败沿用旧布局键。
    }
  }
  if (!account) return null
  return `fullscreen.accounts.user-${encodeURIComponent(account).replace(/\./g, '%2E')}.active`
}

export default {
  namespaced: true,
  state: {
    // 仅控制后台布局；按账号保存在浏览器中，不影响浏览器原生全屏。
    active: false
  },
  actions: {
    /**
     * 进入时只临时折叠布局；退出时先展开菜单，再恢复顶栏。
     */
    async toggle ({ state, commit, dispatch }) {
      if (state.active) {
        await dispatch('d2admin/menu/asideCollapseSet', false, { root: true })
        commit('set', false)
      } else {
        commit('set', true)
      }
      const path = accountStoragePath()
      if (!path) return
      try {
        await dispatch('d2admin/db/set', {
          dbName: 'sys', path, value: state.active, user: false
        }, { root: true })
      } catch (error) {
        // 保存失败不回退当前布局，用户仍可通过退出按钮恢复导航。
        Message.error('布局状态保存失败，刷新后可能无法恢复')
      }
    },
    /**
     * 登录和刷新时恢复当前账号的布局，缺失或无效记录均显示顶栏。
     */
    async load ({ commit, dispatch }) {
      const path = accountStoragePath()
      commit('set', false)
      if (!path) return
      try {
        const active = await dispatch('d2admin/db/get', {
          dbName: 'sys', path, defaultValue: false, user: false
        }, { root: true })
        commit('set', active === true)
      } catch (error) {
        Message.error('布局状态读取失败，已恢复普通布局')
      }
    }
  },
  mutations: {
    /**
     * @description 设置隐藏顶栏的布局状态，业务页面保持挂载
     * @param {Object} state state
     * @param {Boolean} active active
     */
    set (state, active) {
      state.active = active
    }
  }
}
